import apiService from './apiService';

export default (function() {
	var servicePath = '/User';

	// Get information about current user
	function current() {
		var url = servicePath + '/current';

		return apiService.get(url);
	}

	// Get delegators
	function delegators() {
		var url = servicePath + '/delegators';

		return apiService.get(url);
	}

	// Fetch user and config information with a share token
	function fetchShareUser(token, isCampaign = false) {
		if (token) {
			const url = `${servicePath}/${token}/public?isCampaign=${isCampaign}`;

			return apiService.get(url);
		}
	}

	function groups(userId, partnerId) {
		var params = '';

		if (userId && partnerId) {
			params = apiService.paramsToQuery({
				userId: userId,
				partnerId: partnerId
			});
		}
		const url = servicePath + '/groups' + params;

		return apiService.get(url);
	}

	function clients(userId) {
		var params = '';

		if (userId) {
			params = apiService.paramsToQuery({
				userId: userId
			});
		}
		const url = servicePath + '/clients' + params;

		return apiService.get(url);
	}

	function group(groupID) {
		var url = servicePath + '/group?groupID=' + groupID;

		return apiService.get(url);
	}

	return {
		current: current,
		delegators: delegators,
		fetchShareUser: fetchShareUser,
		groups: groups,
		clients: clients,
		group: group
	};
})();